import styled from 'styled-components'

import { Colors } from '~/styles'

const Main = styled.main`
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: ${(props) => (props.height && `${props.height}px`) ?? '100%'};
`

const Section = styled.section`
  width: 100%;
  display: flex;
  padding: 24px;
  justify-content: space-between;
`

const SectionTitle = styled.h1`
  width: 50%;
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${Colors.softBlack};
`

const DropdownContainer = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  justify-content: flex-end;
`

const CardContainer = styled.section`
  gap: 24px;
  width: 100%;
  display: grid;
  padding: 0 24px;
  align-items: flex-start;
  justify-items: center;
  grid-template-columns: ${(props) => props.gridTemplateColumns};
`

const Card = styled.div`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  background-color: rgba(0, 135, 153, 0.1);
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
`

const CardBorder = styled.div`
  width: 100%;
  height: 6px;
  margin-bottom: 8px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23E2E2E2FF' stroke-width='4' stroke-dasharray='12' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
`

const CardContentWrapper = styled.div`
  height: ${(props) => props.height || '100%'};
  padding: 0 24px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 14px;
  margin-bottom: 24px;
`

const CardContentTitle = styled.h2`
  color: ${Colors.cancelTextColor};
  font-size: ${(props) => props.fontSize};
  margin-top: 0;
  margin-bottom: 16px;
`

const ActivityListContainer = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
`

export default {
  Main,
  Card,
  Section,
  CardBorder,
  SectionTitle,
  CardContainer,
  CardContentTitle,
  DropdownContainer,
  CardContentWrapper,
  ActivityListContainer
}